import { motion } from "framer-motion";

const PanelDismiss = ({ className, children, expanded, handle: _handle, onChange, side = "Bottom" }) => {

    const closedBottom = "100%"
    const closedTop = 0
    const closedLeft = 0
    const closedRight = "100%"
 
    const openBottom = 0
    const openTop = 0
    const openLeft = 0
    const openRight = 0

    const initial = {
        "Bottom": { y: closedBottom },
        "Top": { y: -closedTop },
        "Left": { x: -closedLeft },
        "Right": { x: closedRight },
    }

    const animate = {
        "Bottom": { y: openBottom },
        "Top": { y: openTop },
        "Left": { x: openLeft },
        "Right": { x: openRight },
    }

    const variants = {
        open: animate[side],
        closed: initial[side],
    }


    const handlePanEnd = (event, info) => {
        if (Math.abs(info.velocity.y) > 70) {
          onChange();
        }
      };

   
    const drag = side == "Top" || side == "Bottom" ? "y" : "x";
    const dragConstraints = side == "Top" || side == "Bottom" ? { top: 0, bottom: 0 } : { left: 0, right: 0 };
    return ( 
        <motion.div 
            drag={drag} 
            className={className}
            dragConstraints={dragConstraints}
            dragMomentum={false}
            variants={variants}
            animate={expanded ? "open" : "closed"}
            transition={{ type: "ease-out", damping: 0 }}
            onPanEnd={handlePanEnd}
        >
            {children}
        </motion.div>
    );
}

export default PanelDismiss